import { render, staticRenderFns } from "./ItRender.vue?vue&type=template&id=06b0147e&scoped=true"
import script from "./ItRender.vue?vue&type=script&lang=ts"
export * from "./ItRender.vue?vue&type=script&lang=ts"
import style0 from "./ItRender.vue?vue&type=style&index=0&id=06b0147e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b0147e",
  null
  
)

export default component.exports